import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface TerciaryButtonProps {
  label: string;
  colour: "black" | "red";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
}

const TerciaryButton = ({
  label,
  colour = "red",
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  width,
}: TerciaryButtonProps) => {
  return (
    <Button
      label={label}
      size={size}
      type={`terciary-${colour}`}
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default memo(TerciaryButton);
